import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageSettings } from '@/models'
import { resetQueries } from '@/utils/api'

import { getPackagesSettingsQueryKey } from './get-packages-settings'

export const updatePackagesSettings = async (data: Partial<PackageSettings>): Promise<void> => {
  await authAPI.put('/packages/settings', data)
}

export const useUpdatePackagesSettings = (buildingId: number) => {
  return useMutation({
    mutationFn: updatePackagesSettings,
    onSuccess: () => {
      resetQueries(getPackagesSettingsQueryKey({ buildingId }))
    },
  })
}
